import React, { memo } from 'react';
import cls from './TaskCreatedData.module.css';

interface ITaskCreatedDataProps {
    authorName: string;
    createdAtDate: string;
}

export const TaskCreatedData = memo(({ authorName, createdAtDate }: ITaskCreatedDataProps) => {
    return (
        <div className={cls.TaskCreatedDataContainer}>
            <span>Создана {createdAtDate}</span>
            <span>{authorName}</span>
        </div>
    );
});
